<template>
    <div class="data-count">
        <div class="header">
            <nav-top/>
        </div>
        <div class="count-container">
            <div class="count-container-center">
                <div class="count-basis">
                    <div class="basis-top">
                        <span class="tit-icon"></span>
                        <span class="tit">基础统计</span>
                    </div>
                    <div class="basis-bottom">
                        <div class="basis-bottom-l">
                            <p class="basis-tit">检验检测服务总量</p>
                            <span class="data">{{count}}</span><i class="mini">项</i>
                        </div>
                        <div class="basis-bottom-r">
                            <p class="basis-tit">计量校准服务总量</p>
                            <span class="data">{{area}}</span><i class="mini">项</i>
                        </div>
                    </div>
                </div>
                <div class="count-area">
                    <div class="area-top">
                        <span class="tit-icon"></span>
                        <span class="tit">区域统计</span>
                    </div>
                    <div class="area-bottom" id="chart1">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import NavTop from '@/components/common/NavTop'
  import Http from '@/utils/Http'

  export default {
    name: 'dataStatistics',
    data () {
      return {
        count: 0,
        area: 0
      }
    },
    methods: {
      getcCount () {
        Http.fetch(`/data/api/statistic/detection/count`, {}, result => {
          if (result.status === 200) {
            var data = result.data
            this.count = data.toLocaleString()
          }
        })
      },
      getArea () {
        Http.fetch(`/data/api/statistic/metering/count`, {}, result => {
          if (result.status === 200) {
            var data = result.data
            this.area = data.toLocaleString()
          }
        })
      },
      drawLine () {
        let myChart = this.$echarts.init(document.getElementById('chart1'))
        myChart.setOption({
          tooltip: {},
          grid: {},
          xAxis: {
            data: [],
            axisLabel: {
              interval: 0,
              rotate: 45
            }
          },
          yAxis: {},
          series: [{
            name: '总数',
            type: 'bar',
            data: []
          }]
        })
        Http.fetch(`/data/api/statistic/detection/area`, {}, result => {
          if (result.status === 200) {
            let dataArr = result.data
            let key = []
            let value = []
            for (var i = 0; i < dataArr.length; i++) {
              for (var b in dataArr[i]) {
                key.push(b)
                value.push(dataArr[i][b])
              }
            }
            myChart.setOption({
              xAxis: {
                data: key
              },
              series: [{
                data: value
              }]
            })
          }
        })
      }
    },
    mounted () {
      this.drawLine()
      this.getcCount()
      this.getArea()
    },
    components: {
      NavTop
    }
  }
</script>

<style scoped>
    .data-count {
        background: #fff;
    }
    .data-count .count-container {
        width: 100%;
    }

    .count-container .count-container-center {
        width: 1200px;
        margin: 40px auto;
    }

    .data-count .tit-icon {
        display: inline-block;
        width: 4px;
        height: 20px;
        background: #00cccc;
    }

    .data-count .tit {
        font-size: 20px;
        color: #333;
        margin-left: 10px;
    }

    .basis-bottom {
        margin-top: 40px;
    }

    .basis-tit {
        font-size: 16px;
        color: #666;
        margin-bottom: 30px;
    }

    .data {
        font-size: 60px;
        color: #333;
    }

    .mini {
        margin-left: 8px;
    }

    .basis-bottom {
    }

    .basis-bottom .basis-bottom-l {
        float: left;
        margin-right: 300px;
    }

    #chart1 {
        width: 1000px;
        height: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/components/dataCount/dataCount.vue